// product-mcx

import { } from 'antd';
import { useState, useEffect } from 'react'
import { } from '@ant-design/icons';
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import cookie from 'react-cookies'
import Product from '../product/product'

function App(props: any) {
  useEffect(() => {
  }, [])

  return (
    <Product product_category={props.match.params.product_category} cpu_family={window.location.pathname.replace('/product-mcx/' + props.match.params.product_category, '').replace('/', '')} />
  )
}

export default App